module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAAXNSR0IArs4c6QAAATBJREFUKBV9kT1LxEAQhmc2OfwAKzs7sfMqK4sr7PwDgWxOMXcWdta24uE/0EZBDHIQki6dndYaSxu5wkrBA+3uELIZZyMLIcndwO7MvPPwMuwCNESSJCtBGF5WR6Iq6P57MrkAENPqrAYHUeQAQY/P81w4DJM1UPmVhgjzp5kwEeEvTG8JYBUQx4fd7nsVto0QhNEx++3qHoFqrv8638M43swy9cKui1psCiHwSKRp2sqUGs4DEeHel/LGfn0bDRjcanIrNISPZcvyEZFsAvwBpDMDs7hEOZ3onmslLLHnuu646A1k8l0c76hMPRZDgad9zxuYWe1TSKlOAQI+9KQ8N6DONTgn7CDAl7XQ2uc18pmw/hh+423e0z9wnM8yqGurLGy02+vsTH1PXpd1U/8B/alkYflXO9QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-claims_1x.png
// module id = 2310
// module chunks = 0